import { memo } from "react";
import Box from "./Box";

// Static import on purpose: a lazy() Box suspends every header on its first render, which blanks the
// whole page behind the route Suspense fallback.

interface FlexboxProps {
    className?: string;
    children?: React.ReactNode;
    justifyCenter?: boolean;
    justifyAround?: boolean;
    justifyBetween?: boolean;
    justifyEnd?: boolean;
    justifyEvenly?: boolean;
    alignEnd?: boolean;
    alignCenter?: boolean;
    alignTop?: boolean;
    flexColumn?: boolean;
    flexWrap?: boolean;
    onClick?: () => void;
    flexBoxRef?: React.RefObject<HTMLDivElement>;
    gap?: number;
    sx?: React.CSSProperties;
}

const FlexBox: React.FC<FlexboxProps> = ({
    className,
    children,
    justifyCenter,
    justifyAround,
    justifyBetween,
    justifyEnd,
    justifyEvenly,
    alignEnd,
    alignCenter,
    alignTop,
    flexColumn,
    flexWrap,
    onClick,
    flexBoxRef,
    gap,
    sx,
}) => {

    const customStyle: React.CSSProperties = {};

    if (justifyCenter)
        customStyle.justifyContent = "center";

    if (justifyAround)
        customStyle.justifyContent = "space-around";

    if (justifyBetween)
        customStyle.justifyContent = "space-between";

    if (justifyEvenly)
        customStyle.justifyContent = "space-evenly";

    if (justifyEnd)
        customStyle.justifyContent = "end";

    if (alignCenter)
        customStyle.alignItems = "center";

    if (alignTop)
        customStyle.alignItems = "start";

    if (alignEnd)
        customStyle.alignItems = "end";

    if (flexColumn)
        customStyle.flexDirection = "column";

    if (flexWrap)
        customStyle.flexWrap = "wrap";


    return (
        <Box
            className={className}
            onClick={onClick}
            ref={flexBoxRef}
            gap={gap}
            sx={{ display:"flex", ...sx, ...customStyle }}
        >
            {children}
        </Box>
    );
};

export default memo(FlexBox);
